module.exports = __webpack_public_path__ + "img/48_6.6ce4b359.png";